import { VStack } from '@cbhq/cds-web/layout';

import type { AuditEditDetailRowEntry } from '../types';

import { AuditEditDetailRow } from './AuditEditDetailRow';

export type AuditEditDetailSectionProps = {
  rows: AuditEditDetailRowEntry[];
};

export function AuditEditDetailSection({ rows }: AuditEditDetailSectionProps) {
  return (
    <VStack width="100%" gap={0} paddingX={1} testID="audit-edit-detail-section">
      {rows.map((row) => (
        <AuditEditDetailRow key={row.eventId} {...row} />
      ))}
    </VStack>
  );
}
